<app-header [forceLightBackground]="true"></app-header>
<div class="provider-dataset">
  <div class="provider-dataset--layout">
    <app-org-admin-sidebar *ngIf="isOrgAdminRoute" class="provider-dataset--sidebar"></app-org-admin-sidebar>
    <app-provider-sidebar *ngIf="!isOrgAdminRoute" class="provider-dataset--sidebar"></app-provider-sidebar>
    <div class="provider-dataset--content">
      <app-page-header></app-page-header>
      <div class="dataset-container">
        <!-- Step 3 Template -->
        <ng-template #step3Template>
          <div class="step-content">
            <h2 class="step-title">Additional Info</h2>
            
            <!-- Form Fields -->
            <form [formGroup]="additionalInfoForm">
              <div class="form-fields">
                <div class="form-row">
                  <!-- Dataset / Model Type Field -->
                  <div class="form-field col-6">
                    <label for="dataset-type" class="form-label">
                      {{ isModel() ? 'Model Type' : 'Dataset Type' }}
                      <span class="required">*</span>
                    </label>
                    <div class="custom-dropdown-wrapper">
                      <div
                        class="custom-dropdown-trigger"
                        [class.error]="additionalInfoForm.get('datasetType')?.invalid && additionalInfoForm.get('datasetType')?.touched"
                        [class.open]="isDatasetTypeDropdownOpen"
                        (click)="toggleDatasetTypeDropdown()"
                      >
                        <div class="trigger-content">
                          <span *ngIf="!additionalInfoForm.get('datasetType')?.value" class="placeholder">
                            {{ isModel() ? 'Select model type' : 'Select dataset type' }}
                          </span>
                          <span *ngIf="additionalInfoForm.get('datasetType')?.value" class="selected-value">
                            {{ getSelectedDatasetTypeLabel() }}
                          </span>
                          <svg class="dropdown-arrow" [class.open]="isDatasetTypeDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <div class="custom-dropdown-panel" *ngIf="isDatasetTypeDropdownOpen">
                        <div
                          *ngFor="let option of datasetTypeOptions"
                          class="dropdown-option"
                          [class.selected]="isDatasetTypeSelected(option.value)"
                          (click)="selectDatasetType(option)"
                        >
                          <div class="checkbox-wrapper">
                            <div class="checkbox-custom" [class.checked]="isDatasetTypeSelected(option.value)"></div>
                          </div>
                          <span class="option-label">{{ option.label }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      *ngIf="additionalInfoForm.get('datasetType')?.invalid && additionalInfoForm.get('datasetType')?.touched"
                      class="error-message"
                    >
                      {{ isModel() ? 'Model type is required' : 'Dataset type is required' }}
                    </div>
                  </div>

                  <!-- File Format Field -->
                  <div class="form-field col-6">
                    <label for="file-format" class="form-label">
                      File Format <span class="required">*</span>
                    </label>
                    <div class="custom-dropdown-wrapper">
                      <div
                        class="custom-dropdown-trigger"
                        [class.error]="additionalInfoForm.get('fileFormat')?.invalid && additionalInfoForm.get('fileFormat')?.touched"
                        [class.open]="isFileFormatDropdownOpen"
                        [class.disabled]="isFileFormatDisabled()"
                        (click)="toggleFileFormatDropdown()"
                      >
                        <div class="trigger-content">
                          <span *ngIf="!additionalInfoForm.get('fileFormat')?.value" class="placeholder">
                            {{ isFileFormatDisabled() ? 'Select dataset type first' : 'Select file format' }}
                          </span>
                          <span *ngIf="additionalInfoForm.get('fileFormat')?.value" class="selected-value">
                            {{ getSelectedFileFormatLabel() }}
                          </span>
                          <svg class="dropdown-arrow" [class.open]="isFileFormatDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                      </div>
                      <div class="custom-dropdown-panel" *ngIf="isFileFormatDropdownOpen && !isFileFormatDisabled()">
                        <div
                          *ngFor="let option of fileFormatOptions"
                          class="dropdown-option"
                          [class.selected]="isFileFormatSelected(option.value)"
                          (click)="selectFileFormat(option)"
                        >
                          <div class="checkbox-wrapper">
                            <div class="checkbox-custom" [class.checked]="isFileFormatSelected(option.value)"></div>
                          </div>
                          <span class="option-label">{{ option.label }}</span>
                        </div>
                      </div>
                    </div>
                    <div
                      *ngIf="additionalInfoForm.get('fileFormat')?.invalid && additionalInfoForm.get('fileFormat')?.touched"
                      class="error-message"
                    >
                      File format is required
                    </div>
                  </div>
                </div>

                <!-- Tags and Data Source Row -->
                <div class="form-row">
                  <!-- Tags Field -->
                  <div
                    class="form-field"
                    [class.col-6]="isDataSourceUrlEnabled()"
                    [class.col-12]="!isDataSourceUrlEnabled()"
                  >
                    <label for="tags" class="form-label">
                      Tags <span class="required">*</span>
                    </label>
                    <div class="tags-input-wrapper">
                      <div class="tags-input-container">
                        <input
                          type="text"
                          id="tags"
                          class="tags-input"
                          placeholder="Enter a tag"
                          [(ngModel)]="tagInput"
                          [ngModelOptions]="{standalone: true}"
                          (keydown)="onTagInputKeydown($event)"
                          (input)="onTagInputChange()"
                          (paste)="onTagInputPaste($event)"
                        />
                        <button
                          type="button"
                          class="tags-add-button"
                          (click)="addTag()"
                          [disabled]="!canAddTag()"
                          title="Add tag"
                        >
                          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                      </div>
                      <div class="tags-container" *ngIf="getTags().length > 0">
                        <span
                          *ngFor="let tag of getTags()"
                          class="tag-chip"
                          [class.tag-chip--duplicate]="isTagDuplicate(tag)"
                        >
                          {{ tag }}
                          <svg
                            class="tag-chip-close"
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            (click)="removeTag(tag)"
                          >
                            <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </span>
                      </div>
                      <div
                        *ngIf="additionalInfoForm.get('tags')?.invalid && additionalInfoForm.get('tags')?.touched"
                        class="error-message"
                      >
                        At least one tag is required
                      </div>
                    </div>
                  </div>

                  <!-- Data Source Field (optional: if filled, publish from step 3; if empty, proceed to step 4 Upload) -->
                  <div class="form-field col-6" *ngIf="isDataSourceUrlEnabled()">
                    <label class="form-label">
                      Data Source
                      <div class="info-icon-wrapper" [attr.title]="'If you have your information stored in a GitHub repository, you can easily import it to get started instead of uploading files.'">
                        <svg class="info-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M12 16V12M12 8H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </div>
                    </label>
                    <input
                      type="url"
                      formControlName="sampleDataUrl"
                      class="form-input"
                      placeholder="RedirectUrl"
                    />
                    <div
                      *ngIf="additionalInfoForm.get('sampleDataUrl')?.invalid && additionalInfoForm.get('sampleDataUrl')?.touched"
                      class="error-message"
                    >
                      Please enter a valid URL
                    </div>
                  </div>
                </div>

                <!-- Data Descriptor Field (only for datasets) -->
                <div class="form-field" *ngIf="!isModel()">
                  <div class="data-descriptor-header">
                    <label class="form-label">Data Descriptor</label>
                    <button
                      type="button"
                      class="btn-add-descriptor"
                      (click)="openDescriptorModal()"
                    >
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 3V13M3 8H13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      Add Descriptor
                    </button>
                  </div>
                  
                  <!-- Descriptors Table -->
                  <div class="descriptors-table-wrapper" *ngIf="dataDescriptors.length > 0">
                    <table class="descriptors-table">
                      <thead>
                        <tr>
                          <th>Attribute Name</th>
                          <th>Parameter Type</th>
                          <th>Schema Type</th>
                          <th>Description</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let descriptor of getDescriptorsData(); let i = index">
                          <td>{{ descriptor.attributeName }}</td>
                          <td>{{ getParameterTypeLabel(descriptor.parameterType) }}</td>
                          <td>{{ getSchemaTypeLabel(descriptor.schemaType) }}</td>
                          <td class="descriptor-description-cell" [title]="descriptor.description || ''">
                            {{ descriptor.description || '—' }}
                          </td>
                          <td>
                            <div class="table-actions">
                              <button
                                type="button"
                                class="btn-edit"
                                (click)="openDescriptorModal(i)"
                                title="Edit"
                              >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M11.3333 2.00001C11.5084 1.8249 11.7163 1.68696 11.9441 1.59431C12.1719 1.50166 12.4151 1.45605 12.6667 1.45605C12.9182 1.45605 13.1614 1.50166 13.3892 1.59431C13.617 1.68696 13.8249 1.8249 14 2.00001C14.1751 2.17512 14.313 2.38302 14.4057 2.61081C14.4983 2.8386 14.5439 3.08181 14.5439 3.33334C14.5439 3.58487 14.4983 3.82808 14.4057 4.05587C14.313 4.28366 14.1751 4.49156 14 4.66668L5.33333 13.3333L1.33333 14.6667L2.66667 10.6667L11.3333 2.00001Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </button>
                              <button
                                type="button"
                                class="btn-delete"
                                (click)="removeDataDescriptor(i)"
                                title="Delete"
                              >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- Empty State -->
                  <div *ngIf="dataDescriptors.length === 0" class="no-descriptors-message">
                    <p>No data descriptors added. Click "Add Descriptor" to add one.</p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </ng-template>

        <!-- Extra actions inside stepper navigation (Update mode only) -->
        <ng-template #stepperExtraActions>
          <button
            *ngIf="isUpdateMode && showProceedWithoutUpdate"
            class="stepper--btn stepper--btn-next"
            type="button"
            (click)="proceedWithoutUpdate()"
          >
            Proceed without Update
          </button>
        </ng-template>

        <!-- Stepper Component -->
        <app-stepper
          [steps]="filteredStepperSteps"
          [currentStep]="currentStep"
          [customNextButtonLabel]="customNextButtonLabel"
          [disableNextButton]="!canProceedToStep4()"
          [disableStepClick]="shouldDisableStepClick"
          [actionsTemplate]="stepperExtraActions"
          (stepChange)="onStepChange($event)"
          (next)="onNext()"
          (previous)="onPrevious()"
        ></app-stepper>
      </div>
    </div>
  </div>

  <!-- Data Descriptor Modal -->
  <app-modal
    [(visible)]="isDescriptorModalOpen"
    [header]="editingDescriptorIndex !== null ? 'Edit Data Descriptor' : 'Add Data Descriptor'"
    [width]="'600px'"
    [confirmLabel]="'Save'"
    [cancelLabel]="'Cancel'"
    [confirmButtonDisabled]="isDescriptorModalConfirmDisabled()"
    (onConfirm)="saveDescriptor()"
    (onCancel)="closeDescriptorModal()"
  >
    <form [formGroup]="descriptorModalForm" class="descriptor-modal-form">
      <div class="modal-form-fields">
        <!-- Attribute Name -->
        <div class="modal-form-field">
          <label class="form-label">
            Attribute Name <span class="required">*</span>
          </label>
          <input
            type="text"
            formControlName="attributeName"
            class="form-input"
            [class.error]="descriptorModalForm.get('attributeName')?.invalid && descriptorModalForm.get('attributeName')?.touched"
            placeholder="Enter attribute name"
          />
          <div
            *ngIf="descriptorModalForm.get('attributeName')?.hasError('required') && descriptorModalForm.get('attributeName')?.touched"
            class="error-message"
          >
            Attribute name is required
          </div>
          <div
            *ngIf="descriptorModalForm.get('attributeName')?.hasError('duplicateAttributeName') && descriptorModalForm.get('attributeName')?.touched"
            class="error-message"
          >
            Attribute name must be unique
          </div>
        </div>

        <!-- Parameter Type -->
        <div class="modal-form-field">
          <label class="form-label">
            Parameter Type <span class="required">*</span>
          </label>
          <div class="custom-dropdown-wrapper">
            <div
              class="custom-dropdown-trigger"
              [class.error]="descriptorModalForm.get('parameterType')?.invalid && descriptorModalForm.get('parameterType')?.touched"
              [class.open]="isModalParameterTypeDropdownOpen"
              (click)="toggleModalParameterTypeDropdown()"
            >
              <div class="trigger-content">
                <span *ngIf="!descriptorModalForm.get('parameterType')?.value" class="placeholder">Select parameter type</span>
                <span *ngIf="descriptorModalForm.get('parameterType')?.value" class="selected-value">
                  {{ getSelectedModalParameterTypeLabel() }}
                </span>
                <svg class="dropdown-arrow" [class.open]="isModalParameterTypeDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <div class="custom-dropdown-panel" *ngIf="isModalParameterTypeDropdownOpen">
              <div
                *ngFor="let option of parameterTypeOptions"
                class="dropdown-option"
                [class.selected]="isModalParameterTypeSelected(option.value)"
                (click)="selectModalParameterType(option)"
              >
                <div class="checkbox-wrapper">
                  <div class="checkbox-custom" [class.checked]="isModalParameterTypeSelected(option.value)"></div>
                </div>
                <span class="option-label">{{ option.label }}</span>
              </div>
            </div>
          </div>
          <div
            *ngIf="descriptorModalForm.get('parameterType')?.invalid && descriptorModalForm.get('parameterType')?.touched"
            class="error-message"
          >
            Parameter type is required
          </div>
        </div>

        <!-- Schema Type -->
        <div class="modal-form-field">
          <label class="form-label">
            Schema Type <span class="required">*</span>
          </label>
          <div class="custom-dropdown-wrapper">
            <div
              class="custom-dropdown-trigger"
              [class.error]="descriptorModalForm.get('schemaType')?.invalid && descriptorModalForm.get('schemaType')?.touched"
              [class.open]="isModalSchemaTypeDropdownOpen"
              (click)="toggleModalSchemaTypeDropdown()"
            >
              <div class="trigger-content">
                <span *ngIf="!descriptorModalForm.get('schemaType')?.value" class="placeholder">Select schema type</span>
                <span *ngIf="descriptorModalForm.get('schemaType')?.value" class="selected-value">
                  {{ getSelectedModalSchemaTypeLabel() }}
                </span>
                <svg class="dropdown-arrow" [class.open]="isModalSchemaTypeDropdownOpen" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
            </div>
            <div class="custom-dropdown-panel" *ngIf="isModalSchemaTypeDropdownOpen">
              <div
                *ngFor="let option of schemaTypeOptions"
                class="dropdown-option"
                [class.selected]="isModalSchemaTypeSelected(option.value)"
                (click)="selectModalSchemaType(option)"
              >
                <div class="checkbox-wrapper">
                  <div class="checkbox-custom" [class.checked]="isModalSchemaTypeSelected(option.value)"></div>
                </div>
                <span class="option-label">{{ option.label }}</span>
              </div>
            </div>
          </div>
          <div
            *ngIf="descriptorModalForm.get('schemaType')?.invalid && descriptorModalForm.get('schemaType')?.touched"
            class="error-message"
          >
            Schema type is required
          </div>
        </div>

        <!-- Description -->
        <div class="modal-form-field">
          <label class="form-label">Description</label>
          <textarea
            formControlName="description"
            class="form-textarea"
            rows="3"
            placeholder="Describe what this attribute represents"
          ></textarea>
        </div>
      </div>
    </form>
  </app-modal>

  <!-- Success Modal -->
  <app-modal
    [(visible)]="isSuccessModalOpen"
    header="Success"
    [width]="'500px'"
    [showCancelButton]="false"
    [showConfirmButton]="false"
    [footerTemplate]="successModalFooterTemplate"
  >
    <div class="success-modal-content">
      <div class="success-icon-wrapper">
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="30" fill="#4caf50" opacity="0.1"/>
          <path d="M20 32L28 40L44 24" stroke="#4caf50" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <h3 class="success-title">
        <ng-container>{{ isModel() ? 'Model Submitted for Approval' : 'Dataset Submitted for Approval' }}</ng-container>
      </h3>
      <p class="success-message">
        <ng-container *ngIf="isOrgAdminRoute">{{ isModel() ? 'Your model request has been submitted and is awaiting platform admin approval.' : 'Your dataset request has been submitted and is awaiting platform admin approval.' }}</ng-container>
        <ng-container *ngIf="!isOrgAdminRoute">{{ isModel() ? 'Your model has been submitted and is awaiting Organisation Admin approval for metadata and platform admin approval.' : 'Your dataset request has been submitted and is awaiting Organisation Admin approval for metadata and platform admin approval.' }}</ng-container>
      </p>
    </div>
  </app-modal>

  <!-- Success Modal Footer Template -->
  <ng-template #successModalFooterTemplate>
    <div class="success-modal-footer">
      <button
        type="button"
        class="success-modal-btn success-modal-btn-secondary"
        (click)="onCreateNew()"
      >
        Create New
      </button>
      <button
        type="button"
        class="success-modal-btn success-modal-btn-primary"
        (click)="onViewDataset()"
      >
        {{ isModel() ? 'View Model' : 'View Dataset' }}
      </button>
    </div>
  </ng-template>
</div>

